<template>
  <div class="home-index">
    <el-row :gutter="20">
      <el-col
        :xs="1"
        :lg="18"
        style="min-width: 815px"
      >
        <el-row :gutter="20">
          <el-col
            :xs="1"
            :md="24"
            :lg="12"
            :xl="12"
          >
            <CardTypeOne
              :header-title="{
                main: '客户统计',
                sub: '查看客户'
              }"
              view-url="/customer/statistics"
              :datastatics="[
                { value: statisticsCardNumber.totalNumber, label: '客户总数' },
                { value: statisticsCardNumber.newToday, label: '今日新增' }
              ]"
            />
          </el-col>
          <!-- <el-col
            :xs="1"
            :md="24"
            :lg="12"
            :xl="12"
          >
            <CardTypeOne
              :header-title="{
                main: '群统计',
                sub: '查看客户'
              }"
              view-url="/performance/recruitlist"
              :datastatics="[{ value: statisticsCardNumber.customerBaseCount, label: '群总数' }]"
            />
          </el-col> -->
          <el-col
            :xs="1"
            :md="24"
            :lg="12"
            :xl="12"
          >
            <CardTypeOne
              :header-title="{
                main: '导购销售统计',
                sub: '查看销售明细'
              }"
              view-url="/performance/profitlist"
              :money="true"
              :datastatics="[
                { value: money(statisticsCardNumber.totalPayFeeSum), label: '总销售额' },
                { value: money(statisticsCardNumber.todayPayFeeSum), label: '今日销售额' },
                { value: statisticsCardNumber.todayPayNumSum, label: '今日订单数' }
              ]"
            />
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col
            :xs="1"
            :md="24"
            :lg="12"
            :xl="12"
          >
            <CardTypeOne
              :header-title="{
                main: '导购销售统计',
                sub: '查看销售明细'
              }"
              view-url="/performance/profitlist"
              :money="true"
              :datastatics="[
                { value: money(statisticsCardNumber.totalPayFeeSum), label: '总销售额' },
                { value: money(statisticsCardNumber.todayPayFeeSum), label: '今日销售额' },
                { value: statisticsCardNumber.todayPayNumSum, label: '今日订单数' }
              ]"
            />
          </el-col>
          <el-col
            :xs="1"
            :md="24"
            :xl="12"
            :lg="12"
          >
            <CardTypeOne
              :header-title="{
                main: '群销售统计',
                sub: '查看销售明细'
              }"
              view-url="/performance/profitlist?fromHome=community"
              :money="true"
              :datastatics="[
                { value: money(statisticsCardNumber.chatTotalSaleAmount), label: '总销售额' },
                { value: money(statisticsCardNumber.chatTodaySaleAmount), label: '今日销售额' },
                { value: statisticsCardNumber.chatTodayOrderNum, label: '今日订单数' }
              ]"
            />
          </el-col>
        </el-row> -->
        <el-row>
          <el-col
            :xs="1"
            :lg="24"
          >
            <CardTypeOne :line-chart="true">
              <line-chart />
            </CardTypeOne>
          </el-col>
        </el-row>
      </el-col>
      <el-col
        :xs="1"
        :lg="6"
      >
        <!-- <el-row :gutter="20">
          <el-col :xs="1" :lg="24">
            <CardTypeOne />
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col
            :xs="1"
            :lg="24"
          >
            <!-- <AccountInfo /> -->
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :xs="1"
            :lg="24"
          >
            <Histogram />
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col
            :xs="1"
            :lg="24"
          >
            <Help />
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Histogram from './histogram.vue'
import lineChart from './lineChart.vue'
import CardTypeOne from './cardTypeOne'
import Help from './help'
// import AccountInfo from './accountInfo'
export default {
  components: {
    Histogram,
    lineChart,
    CardTypeOne,
    Help
    // AccountInfo
  },
  data () {
    return {
      statisticsCardNumber: {
        totalNumber: 0,
        newToday: 0,
        customerBaseCount: 0,
        totalPayFeeSum: 0,
        todayPayFeeSum: 0,
        todayPayNumSum: 0,
        chatTotalSaleAmount: 0,
        chatTodaySaleAmount: 0,
        chatTodayOrderNum: 0
      },
      lineChartData: []
    }
  },
  computed: {},
  mounted () {
    this.getTotalStatics()
    this.$store.dispatch('getAdminUrl')
  },
  methods: {
    money (num) {
      return `¥ ${(num / 100).toFixed(2)}`
    },
    getTodayItem () {},
    getTotalStatics () {
      this.$api['home/index'].getTotalStatics().then((response) => {
        const {
          member_count,
          today_member_count,
          customer_base_count,
          total_pay_fee_sum,
          today_pay_fee_sum,
          today_pay_num_sum,
          chat_total_sale_amount,
          chat_today_sale_amount,
          chat_today_order_num
        } = response

        this.statisticsCardNumber = {
          totalNumber: member_count,
          newToday: today_member_count,
          customerBaseCount: customer_base_count,
          totalPayFeeSum: total_pay_fee_sum,
          todayPayFeeSum: today_pay_fee_sum,
          todayPayNumSum: today_pay_num_sum,
          chatTotalSaleAmount: chat_total_sale_amount,
          chatTodaySaleAmount: chat_today_sale_amount,
          chatTodayOrderNum: chat_today_order_num
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home-index {
  background: #f0f2f5;
}
.grid-content {
  min-height: 100px;
}
</style>
